import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

const nodeStyles = {
    background: '#1e293b',
    color: '#fff',
    border: '1px solid #334155',
    borderRadius: '8px',
    padding: '10px',
    minWidth: '150px',
    textAlign: 'center',
    fontSize: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
};

const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
    display: 'block'
};

const typeStyle = {
    fontSize: '10px',
    opacity: 0.7,
    textTransform: 'uppercase'
};

export const StartNode = memo(({ data, isConnectable }) => {
    return (
        <div style={{ ...nodeStyles, borderColor: '#22c55e', borderLeftWidth: '4px' }}>
            <span style={labelStyle}>START</span>
            <div style={typeStyle}>Entry Point</div>
            <Handle
                type="source"
                position={Position.Bottom}
                isConnectable={isConnectable}
                style={{ background: '#22c55e' }}
            />
        </div>
    );
});

export const EndNode = memo(({ data, isConnectable }) => {
    return (
        <div style={{ ...nodeStyles, borderColor: '#ef4444', borderLeftWidth: '4px' }}>
            <Handle
                type="target"
                position={Position.Top}
                isConnectable={isConnectable}
                style={{ background: '#ef4444' }}
            />
            <span style={labelStyle}>END</span>
            <div style={typeStyle}>Termination</div>
        </div>
    );
});

export const ActionNode = memo(({ data, isConnectable }) => {
    // Determine style based on node type logic if needed
    // For now generic blue
    let borderColor = '#6366f1';
    let label = data.label || 'Action';
    let subLabel = data.type || 'Generic';

    if (data.type === 'wait_event') {
        borderColor = '#f59e0b'; // Amber for wait
    } else if (data.type === 'send_payment_link' || data.type === 'process_payment') {
        borderColor = '#10b981'; // Emerald for money
    } else if (['send_text', 'send_image', 'send_button_message', 'send_list_message'].includes(data.type)) {
        borderColor = '#8b5cf6'; // Violet for messages
    }

    return (
        <div style={{ ...nodeStyles, borderColor: borderColor, borderLeftWidth: '4px' }}>
            <Handle
                type="target"
                position={Position.Top}
                isConnectable={isConnectable}
                style={{ background: '#94a3b8' }}
            />
            <span style={labelStyle}>{label}</span>
            <div style={typeStyle}>{subLabel}</div>
            <Handle
                type="source"
                position={Position.Bottom}
                isConnectable={isConnectable}
                style={{ background: borderColor }}
            />
        </div>
    );
});
